<form *ngIf="formData && calendarTranslate" [formGroup]="formData" id="formCustomerMg">
  <div class="card">
    <div class="form-group-title">
      <h2>{{'customerInfoSheet.titleInfoCliente' | translate}}</h2>
    </div>
    <div class="ui-g form-group master-data ui-fluid">
      <div [kv-form-element]="{ label: 'customerDetail.cardNo', md: '3', required: !fields.cardNo.nullable }">
        <!--<p-dropdown [disabled]="editMode" [options]="code_cards" formControlName="cardNo" [style]="{'width':'100%' }" (ngModelChange)="codiceCartaChange($event)"></p-dropdown>-->
        <p-autoComplete
          *ngIf="!editMode"
          #autocompleteCard
          id="cardAutocomplete"
          [delay]="600"
          formControlName="cardNo"
          [suggestions]="code_cards"
          (completeMethod)="filterCardSingle($event)"
          (onSelect)="codiceCartaChange($event)"
          [forceSelection]="true"
          placeholder="{{ 'customerInfoSheet.mg_findCard' | translate }}"
          field="label"
          (onDropdownClick)="onClickDropdownCarta($event)"
          [required]="true">
        </p-autoComplete>
        <input #inputCard data-testid="inputCard" type="text" pInputText formControlName="cardNo" *ngIf="editMode" disabled [attr.disabled]="''"/>
        <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="formData" [validation]="fields.cardNo"></app-validation-msg>
      </div>
      <div [kv-form-element]="{ label: 'customerDetail.channel', md: '3', required: !fields.channel.nullable }">
        <p-dropdown [disabled]="true" [options]="channels" formControlName="channel" [style]="{'width':'100%' }"></p-dropdown>
        <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="formData" [validation]="fields.channel"></app-validation-msg>
      </div>
      <div [kv-form-element]="{ label: 'customerDetail.domiciliationStores', md: '3', required: !fields.puntoVendita.nullable }">
        <p-dropdown [filter]="true" [disabled]="editMode" [options]="domiciliationStores" formControlName="puntoVendita" [style]="{'width':'100%' }" (ngModelChange)="puntoVenditaChange($event)"></p-dropdown>
        <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="formData" [validation]="fields.puntoVendita"></app-validation-msg>
      </div>
      <div [kv-form-element]="{ label: 'customerDetail.preferredStores', md: '3', required: !fields.puntoVenditaPref.nullable }">
        <p-dropdown [filter]="true" [options]="preferredStores" formControlName="puntoVenditaPref" [style]="{'width':'100%' }"></p-dropdown>
        <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="formData" [validation]="fields.puntoVenditaPref"></app-validation-msg>
      </div>
    </div>
  </div>
  <div class="card">
    <div class="form-group-title">
      <h2>{{'customerInfoSheet.titleDatiAnagrafici' | translate}}</h2>
    </div>
    <div class="ui-g form-group master-data ui-fluid">
      <div [kv-form-element]="{ label: 'customerDetail.surname', md: '6', required: !fields.cognome.nullable }">
        <input type="text" pInputText formControlName="cognome" />
        <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="formData" [validation]="fields.cognome"></app-validation-msg>
      </div>
      <div [kv-form-element]="{ label: 'customerDetail.name', md: '6', required: !fields.nome.nullable }">
        <input type="text" pInputText formControlName="nome" />
        <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="formData" [validation]="fields.nome"></app-validation-msg>
      </div>
      <div [kv-form-element]="{ label: 'customerDetail.fiscal_code', md: '6', required: !fields.fiscalCode.nullable }">
        <input type="text" pInputText style="text-transform:uppercase" formControlName="fiscalCode" (ngModelChange)="fiscalCodeChange($event)" />
        <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="formData" [arrayValidators]="[validators.fiscalCode]" [validation]="fields.fiscalCode"></app-validation-msg>
      </div>
      <div [kv-form-element]="{ label: 'customerDetail.birthday', md: '3', required: !fields.birthDate.nullable }">
        <app-kv-calendar
          class="over"
          [inputName]="'birthDate'"
          [defaultDate]="formData.controls.birthDate.value"
          [defaultValue]="formData.controls.birthDate.value"
          [formData]="formData"
          [maxDate]="maxDate"
          [yearRange]="'1900:2019'"
          [disabled]="true"
        ></app-kv-calendar>
        <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="formData" [validation]="fields.birthDate"></app-validation-msg>
      </div>
      <div [kv-form-element]="{ label: 'customerDetail.sex', md: '3', required: !fields.sex.nullable }">
        <p-dropdown [options]="sex" formControlName="sex" [style]="{'width':'100%' }" [disabled]="true"></p-dropdown>
        <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="formData" [validation]="fields.sex"></app-validation-msg>
      </div>
      <div [kv-form-element]="{ label: 'customerDetail.mobile', md: '6', required: !fields.mobile.nullable }">
        <input type="text" pInputText formControlName="mobile" />
        <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="formData" [arrayValidators]="[validators.phone]" [validation]="fields.mobile"></app-validation-msg>
        <div class="input-error-notification" *ngIf="showEmailOrMobileError">{{ 'customerDetail.email_or_mobile_error' | translate }}</div>
      </div>
      <div [kv-form-element]="{ label: 'customerDetail.mail_1', md: '6', required: !fields.email.nullable }">
        <input type="text" pInputText formControlName="email" />
        <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="formData" [arrayValidators]="[validators.emailOrEmpty]" [validation]="fields.email"></app-validation-msg>
        <div class="input-error-notification" *ngIf="showEmailOrMobileError">{{ 'customerDetail.email_or_mobile_error' | translate }}</div>
      </div>
    </div>
  </div>
  <div class="card">
    <div class="form-group-title">
      <h2>{{'customerInfoSheet.titleIndirizzo' | translate}}</h2>
    </div>
    <div class="ui-g form-group master-data ui-fluid">
      <div [kv-form-element]="{ label: 'customerDetail.toponym', md: '3', required: !fields.toponym.nullable }">
        <p-dropdown [options]="toponyms" formControlName="toponym" [filter]="true" [style]="{'width':'100%' }"></p-dropdown>
        <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="formData" [validation]="fields.toponym"></app-validation-msg>
      </div>
      <div [kv-form-element]="{ label: 'customerDetail.address_venue', md: '6', required: !fields.address.nullable }">
        <input type="text" pInputText formControlName="address" />
        <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="formData" [validation]="fields.address"></app-validation-msg>
      </div>
      <div [kv-form-element]="{ label: 'customerDetail.number', md: '3', required: !fields.addressNumber.nullable }">
        <input type="text" pInputText formControlName="addressNumber" />
        <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="formData" [validation]="fields.addressNumber"></app-validation-msg>
      </div>
      <div [kv-form-element]="{ label: 'customerDetail.city', md: '6', required: !fields.comune.nullable }">
        <input type="text" pInputText formControlName="comune" />
        <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="formData" [validation]="fields.comune"></app-validation-msg>
      </div>
      <div [kv-form-element]="{ label: 'customerDetail.zip', md: '3', required: !fields.zipCode.nullable }">
        <input type="text" pInputText formControlName="zipCode" minlength="5" />
        <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="formData" [arrayValidators]="[validators.zipCodeValidator]" [validation]="fields.zipCode"></app-validation-msg>
      </div>
      <div [kv-form-element]="{ label: 'customerDetail.province', md: '3', required: !fields.province.nullable }">
        <p-dropdown [options]="provinces" formControlName="province" [filter]="true" [style]="{'width':'100%' }"></p-dropdown>
        <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="formData" [validation]="fields.province"></app-validation-msg>
      </div>
    </div>
  </div>
  <div class="card">
    <div class="form-group-title">
      <h2>{{'customerInfoSheet.titleAutorizzazioni' | translate}}</h2>
    </div>
    <div class="ui-g form-group master-data ui-fluid">
      <div [kv-form-element]="{ label: 'customerDetail.flgAuth1', md: '6', required: !fields.flgAuth1.nullable }">
        <p-inputSwitch formControlName="flgAuth1"></p-inputSwitch>
        <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="formData" [validation]="fields.flgAuth1"></app-validation-msg>
      </div>
      <div [kv-form-element]="{ label: 'customerDetail.flgAuth2', md: '6', required: !fields.flgAuth2.nullable }">
        <p-inputSwitch formControlName="flgAuth2"></p-inputSwitch>
        <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="formData" [validation]="fields.flgAuth2"></app-validation-msg>
      </div>
      <div [kv-form-element]="{ label: 'customerDetail.flgAuth3', md: '6', required: !fields.flgAuth3.nullable }">
        <p-inputSwitch formControlName="flgAuth3"></p-inputSwitch>
        <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="formData" [validation]="fields.flgAuth3"></app-validation-msg>
      </div>
      <div *ngIf="fields.flgAuthPush" [kv-form-element]="{ label: 'customerDetail.authorization_push', md: '6', required: !fields.flgAuthPush.nullable }">
        <p-inputSwitch formControlName="flgAuthPush"></p-inputSwitch>
        <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="formData" [validation]="fields.flgAuthPush"></app-validation-msg>
      </div>
    </div>
  </div>
</form>



// WEBPACK FOOTER //
// ./src/app/views/customerDB/customers/basicinfonew/basicnew.component.html